export default [
  {
    path: 'courses',
    component: () => import('@/App.vue'),
    meta: {
      title: 'Courses',
      sort: 6,
      authenticatable: true,
      icon: 'mdi-flask',
    },
    children: [
      {
        path: ':slug/overview',
        props: true,
        name: 'courses.overview',
        component: () => import('../Overview.vue'),
        meta: {
          title: 'Course Overview',
          sort: 6,
          authenticatable: true,
          icon: 'mdi-flask'
        },
      },
      {
        path: ':slug',
        name: 'courses.show',
        redirect: { name: 'courses.overview' },
        component: () => import('@/components/Layouts/Dashboard.vue'),
        meta: {
          title: ':slug',
          sort: 5,
        },
        children: [
          {
            path: ':lesson',
            name: 'courses.single',
            component: () => import('../Single.vue'),
            meta: {
              title: ':slug',
              sort: 1,
            },
          },
        ],
      },
    ],
  }
]
